import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";

import CloseIcon from "@mui/icons-material/Close";
import Assessment from "@mui/icons-material/Assessment";
import { TransitionProps } from "@mui/material/transitions";
import { FormLabel, Grid, IconButton, Stack, TextField, Typography } from "@mui/material";
import { CreateIssueRequestInput } from "../common/models";
import { useState } from "react";
import { validateEmail } from "../common/utils";
import axios from "axios";
import { useMutation } from "react-query";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export interface IReportIssueModalProps {
  open: boolean;
  handleClose: (e?: any, reason?: "backdropClick" | "escapeKeyDown") => void;
}

export default function ReportIssueModal(props: IReportIssueModalProps) {
  const [issue, setIssue] = useState<CreateIssueRequestInput>({ email: "", report: "" } as CreateIssueRequestInput);
  const [isEmailValid, setIsEmailValid] = useState(true);
  const { open, handleClose } = props;
  const isModelValid = issue.email != "" && issue.report != "" && isEmailValid;
  const {
    mutate: creatIssue,
    isLoading,
    isError,
  } = useMutation("create-issue", (data: CreateIssueRequestInput) => {
    return axios.post("/api/user-reports/", data);
  });
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
      sx={{
        "& .MuiPaper-root": {
          width: "100%",
          maxWidth: "60%",
        },
        backdropFilter: "blur(5px)",
        paddingTop: "50px",
        paddingBottom: "50px",
      }}
    >
      <DialogTitle display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <Assessment sx={{ width: "20px", height: "20px" }} />
          <Typography
            sx={{
              fontWeight: "100",
              margin: "4px !important",
              fontSize: "20px",
            }}
          >
            Problem Melden
          </Typography>
        </Stack>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} justifyContent="start">
          {/* Email */}
          <Grid item md={12}>
            <Stack spacing={1}>
              <FormLabel>E-Mail:</FormLabel>
              <TextField
                required
                onBlur={() => {
                  if (issue.email != "") {
                    setIsEmailValid(validateEmail(issue.email));
                  }
                }}
                error={!isEmailValid}
                helperText={!isEmailValid ? "Enter Valid Email" : ""}
                id="outlined-required"
                placeholder="Geben Sie Ihre E-Mail-Adresse ein"
                value={issue.email}
                onChange={(e: any) => {
                  setIssue({ ...issue, email: e.target.value });
                }}
              />
            </Stack>
          </Grid>
          {/* Descriptions */}
          <Grid item md={12}>
            <Stack spacing={1}>
              <FormLabel>Beschreibung:</FormLabel>
              <TextField
                required
                id="outlined-required"
                placeholder="Geben Sie Ihre Beschreibung ein"
                multiline
                rows={5}
                value={issue.report}
                onChange={(e: any) => setIssue({ ...issue, report: e.target.value })}
              />
            </Stack>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
        <Button
          variant="contained"
          onClick={() => {
            creatIssue(issue);
          }}
          disabled={!isModelValid || isLoading}
        >
          {isLoading ? "Submitting" : "Submit"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
